<template>
  <div class="mt-15 container-inner">
    <h3 class="title-type-2">
      <strong>{{ inventory.name }}</strong> 상품 세부 설정
    </h3>
    <div class="mb-8">
      <h4 class="title-type-3">
        지면설명
        <span class="attention-coment-1 ml-2">
          <v-icon>mdi-alert-circle</v-icon>
          라운드 진입 1홀 동영상 광고 지면 그룹코드로 관리되며 챔피언십 모드 /
          CC 를 지원한다. (홀넘버는 선택할 수 없다. 1홀 이전 출력 고정 상품)
        </span>
      </h4>
    </div>
    <v-form v-model="valid" ref="form">
      <!-- 모드 -->
      <div class="mb-8">
        <h4 class="title-type-3">
          모드
          <v-tooltip right content-class="tooltip-custom-1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-2" v-bind="attrs" v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>노출 모드 선택 (스트로크, 챔피언십) </span>
          </v-tooltip>
        </h4>
        <div class="relative white rounded pa-6 pr-16">
          <div class="form-row-1">
            <p class="label">
              모드 선택
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-select
                :items="searchMode"
                :label="searchMode[0]"
                v-model="selMode"
                item-color="#000"
                class="input-custom-2"
                height="40px"
                solo
                required
                hide-details
                @change="selectMode($event)"
              ></v-select>
            </div>
          </div>
          <div class="form-row-1 mt-4" v-if="this.selMode === '챔피언십'">
            <p class="label">
              대회ID
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                v-model="competitionId"
                label="대회 아이디 값을 직접 입력해주세요."
                class="input-custom-2"
                height="40px"
                solo
                :rules="competitioRules"
                required
              ></v-text-field>
              <p class="form-coment-1 mt-n2">
                <v-icon>mdi-alert-circle-outline</v-icon>
                숫자만 가능합니다.
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- //모드 -->
      <!-- CC 코스 -->
      <div class="mb-8">
        <h4 class="title-type-3">
          CC 코스
          <v-tooltip right content-class="tooltip-custom-1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-2" v-bind="attrs" v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>선택 지면이 노출될 CC 선택</span>
          </v-tooltip>
        </h4>
        <div class="relative white rounded pa-6 pr-16">
          <div class="form-row-1">
            <p class="label">
              CC선택
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <div class="d-flex">
                <div style="height: 48px">
                  <v-radio-group v-model="ccCourse" class="mt-0 pt-2" row>
                    <v-radio
                      v-if="isShowAllCC"
                      label="전체 CC"
                      value="all"
                      color="#fecd00"
                      class="radio-type-1 mr-10"
                    ></v-radio>
                    <v-radio
                      v-if="isShowSelCC"
                      label="지정 CC"
                      value="sel"
                      color="#fecd00"
                      class="radio-type-1"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div v-if="this.ccCourse === 'sel'">
                  <div class="relative">
                    <div class="search-1">
                      <span class="readinput" style="width: 350px">
                        <v-text-field
                          class="input-custom-2"
                          height="40px"
                          min-width="300px"
                          v-model="selCC"
                          hide-details
                          solo
                          readonly
                          @click.stop="openCCcoursePopup"
                        ></v-text-field>
                      </span>
                      <v-btn
                        depressed
                        large
                        max-height="40px"
                        color="#fecd06"
                        class="button-type-1 ml-2"
                        @click.stop="openCCcoursePopup"
                      >
                        찾기
                      </v-btn>
                      <v-btn
                        depressed
                        large
                        max-height="40px"
                        color="#fff"
                        class="button-type-1 ml-2"
                        @click.stop="ccCourseCancel"
                      >
                        취소
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--// CC 코스 -->
      <!-- mode cc save btn -->
      <div class="d-flex justify-end mt-10 mb-10">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fff"
          class="button-type-1"
          @click.stop="cancel"
        >
          취소
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1 ml-4"
          @click.prevent="saveLineItem"
          :disabled="
            !valid || !this.ccCourse || (this.ccCourse === 'sel' && !this.selCC)
          "
        >
          저장
        </v-btn>
      </div>
      <!--// mode cc save btn -->
    </v-form>
    <v-expand-transition>
      <div v-if="lriContent">
        <!-- 그룹코드 -->
        <div class="mb-8">
          <h4 class="title-type-3">
            그룹코드
            <v-tooltip right content-class="tooltip-custom-1">
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-2" v-bind="attrs" v-on="on"
                  >mdi-alert-circle-outline</v-icon
                >
              </template>
              <span>
                4구좌의 광고를 2개 그룹으로 묶어 광고 송출을 하기 위해
                그룹코드를 추가한다.</span
              >
            </v-tooltip>
          </h4>
          <div class="relative white rounded pa-6 pr-16">
            <div class="form-row-1">
              <p class="label">
                그룹 선택
                <span class="required">
                  <v-icon>mdi-check-circle-outline</v-icon>
                  필수
                </span>
              </p>
              <div class="write-con">
                <v-select
                  :items="searchGroupCode"
                  label="선택"
                  v-model="selGroup"
                  item-color="#000"
                  class="input-custom-2"
                  height="40px"
                  solo
                  required
                  hide-details
                  @change="selGroupChecked(selGroup, searchGroupCode)"
                ></v-select>
              </div>
            </div>
          </div>
        </div>
        <!-- //그룹코드 -->
        <!-- 영상 업로드 -->
        <div class="mb-8">
          <h4 class="mt-8 title-type-3">영상 업로드</h4>
          <div class="resource-wrap">
            <ResourceVideo1
              :propsInventoryType="inventory.type"
              :propsInventoryId="propsInventoryId"
              :propsInventory="inventory"
              :propsLineItemId="lineItemId"
              :propsLriId="lriId"
              :propsResources="resources"
              :propsAdvertiserId="propsAdvertiserId"
              @getResourceAfterAdd="updateDetailLineitemForResource"
              @getResourceAfterDelete="deleteDetailLineitemForResource"
            />
          </div>
        </div>
      </div>
    </v-expand-transition>
    <!-- //영상 업로드 -->
    <div v-if="this.searchCCcourse">
      <SearchCCModal
        v-model="searchCCcourse"
        @select:ccCourse="selectCCcourse"
      />
    </div>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import SystemAlert from '~@/modal/SystemAlert.vue';
import { toISOFormattedDate } from '@/utils/validation';
import { optionsList } from '@/api/options';

import {
  getDetailCampaignLineItem,
  updateDetailCampaignLineItem,
  addOptionItem,
  updateOptionItem,
} from '@/api/campaign';

import moment from 'moment';
import ResourceVideo1 from './resourceVideo1.vue';
import SearchCCModal from '~@/modal/SearchCCModal.vue';

let defaultStartAt = new Date();
defaultStartAt.setHours(0, 0, 0, 0);
defaultStartAt = moment(defaultStartAt);

let defaultEndAt = new Date();
defaultEndAt.setHours(23, 59, 0, 0);
defaultEndAt = moment(defaultEndAt).add(1, 'months');

export default {
  components: {
    SystemAlert,
    ResourceVideo1,
    SearchCCModal,
  },
  props: {
    propsInventory: Object,
    propsInventoryId: String,
    propsLineItem: Object,
    propsDateRange: Object,
    propsAdvertiserId: String,
  },
  data: () => ({
    valid: false,
    lriContent: false,

    showSystemAlert: false,
    logResult: '',

    searchGroupCode: [],
    selGroup: '',
    optionsGroupMap: {},

    searchMode: [],
    selMode: '',
    optionsModeMap: {},
    competitionId: '',
    competitioRules: [
      v => !!v || '대회 아이디를 입력해주세요.',
      v => (v && /^[0-9]+$/.test(v)) || '숫자만 가능합니다.',
    ],

    searchCC: [],
    ccCourse: null,
    selCC: '',
    optionsCCMap: {},
    isShowAllCC: true,
    isShowSelCC: true,

    isValid: 'Y',

    options: [],
    optionItemsMap: {},

    lineItem: {},
    lineItemId: '',
    lris: [],
    lri: {},
    lriId: '',
    lrisMap: {},

    resources: [],
    defaultResource: {
      dateRange: { startDate: null, endDate: null },
      id: '',
      name: '',
      start_at: null,
      end_at: null,
      is_valid: '',
      type: 0,
      hash: '',
      file: '',
    },
    resourceId: '',
    searchCCcourse: false,
  }),
  computed: {
    inventory: {
      get() {
        return this.propsInventory;
      },
      set(value) {
        this.propsInventory = value;
      },
    },
    defaultStartAt() {
      return this.propsInventory.start_at;
    },
    defaultEndAt() {
      return this.propsInventory.end_at;
    },
  },
  methods: {
    openCCcoursePopup() {
      this.searchCCcourse = true;
    },
    selectCCcourse(data) {
      this.selCC = data.name;
    },
    ccCourseCancel() {
      this.selCC = '';
    },
    async getOptions() {
      try {
        const { data } = await optionsList();
        this.options = data.list;
        const modeMap = {};
        const ccMap = {};
        const groupMap = {};
        const optionItemsArray = [];
        const optionItemsMap = {};
        (this.options || []).forEach(option => {
          if (option.name === '모드' && !option.key) {
            option.items.forEach(item => {
              modeMap[item.name] = item;
            });
          }
          if (option.name === 'CC 코스' && !option.key) {
            option.items.forEach(item => {
              ccMap[item.name] = item;
            });
          }
          if (option.name === '그룹' && !option.key) {
            option.items.forEach(item => {
              groupMap[item.name] = item;
            });
          }
          option.items.forEach(item => {
            optionItemsArray.push(item);
          });
        });

        (optionItemsArray || []).forEach(item => {
          optionItemsMap[item.id] = item;
        });

        this.optionsGroupMap = groupMap;
        this.optionsModeMap = modeMap;
        this.optionsCCMap = ccMap;

        this.searchGroupCode = Object.keys(groupMap);
        this.searchMode = Object.keys(modeMap);
        this.searchCC = Object.keys(ccMap);

        this.optionItemsMap = optionItemsMap;
      } catch (error) {
        console.log(error.response);
      }
    },
    //처음 페이지 로딩 시 라인아이템 블러오기
    async getDetailLineItem(emitData) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const LineItemId = this.propsLineItem.id;
      try {
        const { data } = await getDetailCampaignLineItem(
          campaignId,
          inventoryId,
          LineItemId,
        );

        //lineItem과 lineItemId를 세팅한다.
        this.lineItem = data.row.medias[0].inventories[0].lineitems[0];
        this.lineItemId = data.row.medias[0].inventories[0].lineitems[0].id;

        if (this.lineItem.lris.length > 0) {
          this.lriContent = true;
          //lirs 세팅
          this.lris = this.lineItem.lris;

          this.lri = this.lineItem.lris[0];
          this.lriId = this.lineItem.lris[0].id;
          this.resources = this.lineItem.lris[0].resources;

          //그룹 선택하고 리소스가 없을 시
          if (this.lriId && this.resources.length === 0) {
            this.defaultResource.dateRange.startDate = this.defaultStartAt;
            this.defaultResource.dateRange.endDate = this.defaultEndAt;
            this.defaultResource.start_at = this.defaultStartAt;
            this.defaultResource.end_at = this.defaultEndAt;
            this.resources.push(
              JSON.parse(JSON.stringify(this.defaultResource)),
            );
          }

          //그룹 코드 세팅
          if (this.lri.item_id) {
            this.selGroup = this.optionItemsMap[this.lri.item_id].name;
          }
        } else {
          this.resources = [];
          this.defaultResource.dateRange.startDate = this.defaultStartAt;
          this.defaultResource.dateRange.endDate = this.defaultEndAt;
          this.defaultResource.start_at = this.defaultStartAt;
          this.defaultResource.end_at = this.defaultEndAt;
          this.resources.push(JSON.parse(JSON.stringify(this.defaultResource)));
        }

        //resources 갱신
        if (emitData) {
          this.lris.forEach(lri => {
            if (lri.id === emitData.lriId) {
              this.resources = lri.resources;
            }
          });
          //resource가 없을 땐 defaultResource 넣어줌
          if (this.resources.length === 0 || !this.resources[0].id) {
            this.resources = [];
            this.defaultResource.dateRange.startDate = this.defaultStartAt;
            this.defaultResource.dateRange.endDate = this.defaultEndAt;
            this.defaultResource.start_at = this.defaultStartAt;
            this.defaultResource.end_at = this.defaultEndAt;
            this.resources.push(
              JSON.parse(JSON.stringify(this.defaultResource)),
            );
          }
          this.$emit('upadate:campaignInfo');
        }

        //노출정보 세팅
        this.isValid = this.lineItem.is_valid;

        //모드세팅
        if (this.lineItem.mode) {
          this.selMode = this.optionItemsMap[this.lineItem.mode].name;
          this.competitionId = this.lineItem.competition_id;
        } else {
          this.selMode = this.searchMode[0];
        }

        //CC세팅(cc가 null이면 전체선택)
        if (this.lineItem.cc) {
          this.ccCourse = 'sel';
          this.selCC = this.optionItemsMap[this.lineItem.cc].name;
          this.isShowSelCC = true;
          this.isShowAllCC = false;
        } else {
          this.ccCourse = 'all';
          this.isShowSelCC = false;
          this.isShowAllCC = true;
        }

        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },

    selGroupChecked(value) {
      let lriData = {
        item_id: this.optionsGroupMap[value].id,
      };
      if (this.lris.length > 0) {
        this.updateLri(lriData);
      } else {
        this.addLri(lriData);
      }
    },
    async addLri(lriData) {
      bus.$emit('start:spinner');
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;

      try {
        const { data } = await addOptionItem(
          campaignId,
          inventoryId,
          lineItemId,
          lriData,
        );
        if (data.result === 'success') {
          this.lriId = data.value;
          await this.getDetailLineItem();
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult = '선택된 지면은 현재 집행중인 <br>캠페인이 있습니다.';
          this.selGroup = '';
          await this.getDetailLineItem();
        }
      }
    },

    async updateLri(lriData) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;
      const lriId = this.lri.id;
      try {
        const { data } = await updateOptionItem(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          lriData,
        );
        this.$forceUpdate();
        await this.getDetailLineItem();
      } catch (error) {
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult = '선택된 지면은 현재 집행중인 <br>캠페인이 있습니다.';
          await this.getDetailLineItem();
        }
      }
    },

    async saveLineItem() {
      bus.$emit('start:spinner');
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;

      let mode = this.selMode
        ? (mode = this.optionsModeMap[this.selMode].id)
        : null;

      let cc = '';
      if (this.ccCourse !== 'all' && this.selCC) {
        cc = this.optionsCCMap[this.selCC].id;
      } else {
        cc = null;
        this.selCC = '';
      }

      let competition_id = '';
      if (this.ccCourse !== 'all' && this.competitionId) {
        competition_id = this.competitionId;
      } else {
        competition_id = null;
      }

      let updateData = {
        is_valid: this.isValid,
        start_at: toISOFormattedDate(new Date(this.propsDateRange.startDate)),
        end_at: toISOFormattedDate(new Date(this.propsDateRange.endDate)),
        mode: mode,
        cc: cc,
        competition_id: competition_id,
      };

      try {
        const { data } = await updateDetailCampaignLineItem(
          campaignId,
          inventoryId,
          lineItemId,
          updateData,
        );
        if (data.result === 'success') {
          this.showSystemAlert = true;
          this.logResult = `저장되었습니다.<br>아래 그룹코드를 선택하신 후,<br>소재등록 바랍니다.`;
        }
        await this.getDetailLineItem();
        this.lriContent = true;

        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult =
            '선택하신 캠페인에 포함된 상품(지면)중 <br>현재 다른 캠페인에서 사용중인 지면이 <br>포함되어 있습니다.<br><br>지면별 일정을 확인 / 수정후<br>다시 시도해주시기 바랍니다.';
        }
      }
    },
    updateDetailLineitemForResource(data) {
      this.getDetailLineItem(data);
    },
    deleteDetailLineitemForResource(data) {
      this.getDetailLineItem(data);
    },
    selectMode(e) {
      if (e === '스트로크') {
        this.ccCourse = 'all';
        this.isShowAllCC = true;
        this.isShowSelCC = false;
      } else {
        this.ccCourse = 'sel';
        this.isShowAllCC = false;
        this.isShowSelCC = true;
      }
    },
    cancel() {
      this.$emit('close:detail', this.propsInventory);
    },
  },
  async created() {
    bus.$emit('start:spinner');
    await this.getOptions();
    await this.getDetailLineItem();
  },
};
</script>

<style scoped></style>
